import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.aufgabe-bemerkung-erfassen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenAufgabeBemerkungErfassenEffects {

    AufgabeBemerkungErfassen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_AUFGABE_BEMERKUNG_ERFASSEN),
        mergeMap((x: ac.PostAufgabeBemerkungErfassenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postAufgabeBemerkungErfassen(x.aufgabeBemerkungRequest).pipe(
                map((result: any) => {
                    return new ac.PostAufgabeBemerkungErfassenErfolgreichAction(result, x.aufgabeBemerkungRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostAufgabeBemerkungErfassenFehlerAction(error, x.aufgabeBemerkungRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AufgabenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AufgabenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AufgabenCommandService);
        }
        return this.service;
    }
}
